module.exports = __webpack_public_path__ + "static/52-Adobe-f313d13af746c7f3af9e0acc1904f9b6.png";